import React, { useEffect, useState } from 'react';
import { NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { setYearList, setMonthList, setDateRange, formatDate } from './Function';
import { Row, Col, Card, Table, Form, InputGroup, Placeholder, Button, Spinner } from 'react-bootstrap';
const ExamTypeArchive = ({ etId,cardHeading }) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const [isLoading, setLoading] = useState(true);
    const [isLoadMore, setLoadMore] = useState(true);
    const [Rows, setRows] = useState(0);
    const [Exams, setExams] = useState([]);
    const [keyword, setKeyword] = useState('');
    const [year, setYear] = useState(0);
    const [month, setMonth] = useState(0);
    const KeywordChange = (e) => setKeyword(e.target.value.trim() || '');
    const YearChange = (e) => setYear(Number(e.target.value) || 0);
    const MonthChange = (e) => setMonth(Number(e.target.value) || 0);
    useEffect(()=>
    {
        fetchExams(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    const fetchExams = async (isReset) => 
    {
        if (isReset === true)
        {
            setRows(0);
            setExams([]);
        }
        try 
        {
            setLoading(true);
            var keywordText = keyword || 'none';
            const { startDate, endDate } = setDateRange(year, month, 0, 1, 0);
            const currentRows = isReset ? 0 : Rows;
            const callApi = global.config.API_URL + `exams/list/${etId}/${keywordText}/${startDate}/${endDate}/${currentRows}`;
            if(global.config.IsPrint) console.info('ExamsList : API', callApi);
            const response = await fetch(callApi);
            const result = await response.json();
            if (result.length > 0) 
            {
                setExams(prevResults => Rows === 0 ? result : [...prevResults, ...result]);
                setRows(currentRows + 30);                
                setLoadMore(true);
            } 
            else 
            {
                setLoadMore(false);
            }            
        } catch (error) 
        {
            console.error('ExamsList : Error', error.message);
        } 
        finally 
        {
            setLoading(false);
        }
    };
    const handleSubmit = (e) => 
    {
        e.preventDefault();
        if (!keyword && year === 0 && month === 0) 
        {
            alert(t('FilterAlert'));
            return;
        }
        fetchExams(true);
    };
    return (
        <Card className='bg-secondary-subtle mb-4'>
            <Card.Header className='text-center text-uppercase fs-3' data-aos="flip-up" data-aos-duration="1500">
                {cardHeading}
            </Card.Header>
            <Card.Body>
                <Card className=' mb-3'>
                    <Card.Body>
                        <form onSubmit={handleSubmit}>
                        <div className='mb-2 fw-bold'>{t('FilterSearch')}</div>
                        <Row className='g-2'>                            
                            <Col md={6} data-aos="fade-right" data-aos-duration="1000">
                                <Form.Control type="text" placeholder={t('FilterPlaceholder')} onChange={KeywordChange} value={keyword} />
                            </Col>
                            <Col md={6} data-aos="fade-left" data-aos-duration="1000">
                                <InputGroup>
                                    <Form.Select onChange={YearChange} value={year}>
                                        <option value={0}>{t('FilterYear')}</option>
                                        {setYearList(0, 1).map((year) => (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    <Form.Select onChange={MonthChange} value={month}>
                                        <option value={0}>{t('FilterMonth')}</option>
                                        {setMonthList().map(({ value, label }) => (
                                            <option key={value} value={value}>
                                                {label}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    <Button className='btn btn-info' type='submit'><i className="bi bi-search"></i> {t('FilterSearch')}</Button>
                                </InputGroup>
                            </Col>
                        </Row>
                        </form>
                    </Card.Body>
                </Card>
                <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
                    <thead>
                    <tr>
                        <th className='w-50'>{t('Title')}</th>
                        <th>{t('Download')}</th>
                        <th>{t('Duration')}</th>                        
                    </tr>
                    </thead>
                    {isLoading ? (
                        <tbody>
                            {[...Array(10)].map((_, index) => (
                                <tr key={index}>
                                    <th className="table-success"><Placeholder xs={10} bg="success" /></th>
                                    <td className="text-center">
                                        <Button className="btn btn-light w-100"><Placeholder xs={10} bg="dark" /></Button>
                                    </td>
                                    <td><Placeholder xs={10} bg="dark" /></td>
                                </tr>
                            ))}
                        </tbody>
                    ) : (
                        <tbody>
                            {Exams.map((se, index) => (
                                <tr key={index}>
                                    <th className="table-success" dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (se.se_display_en === "1" ? se.se_name_hi || '' : se.se_name_hi || se.se_name) : se.se_name }}></th>
                                    <td className="text-center">
                                        <NavLink to={appLanguage === 'hi' ? `/परीक्षा/विवरण/${se.se_htaccess_hi || se.se_htaccess}` : `/exam/details/${se.se_htaccess}`} className="btn btn-light" target='_blank' rel="noopener noreferrer">
                                            {t('ViewDownload')}
                                        </NavLink>
                                    </td>
                                    <td>{formatDate(se.se_date)}</td>
                                </tr>
                            ))}
                        </tbody>
                    )}
                </Table>
                {isLoadMore &&
                <div className='text-center p-3'>
                    <Button className='btn btn-info mt-3' onClick={() => fetchExams(false)} disabled={isLoading}>
                        {isLoading ? (
                        <React.Fragment>
                            <Spinner animation="grow" variant="light" size="sm" />
                            <Spinner animation="grow" variant="danger" size="sm" />
                            <span className='ms-2'>{t('PleaseWait')}</span>
                        </React.Fragment>
                        ) : t('LoadMore')}
                    </Button>
                </div>}                
            </Card.Body>
        </Card>
    );
}
export default ExamTypeArchive;
